// ACTIVITIES
export const activityDocs = [
  {
    id: 'activities_shortcuts',
    label: 'Navigation from Activities '
  }
];
